import { z } from 'zod';

export const DocumentTypeSchema = z.object({
    id: z.string().optional(),
    documentCategory: z.string().min(1, 'form.validation.documentCategoryRequired'),
    documentTypeAbbreviation: z.string().min(1, 'form.validation.documentTypeAbbreviationRequired'),
    complianceCategory: z.string().min(1, 'form.validation.complianceCategoryRequired'),
    isActive: z.boolean().default(true),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const CreateDocumentTypeSchema = DocumentTypeSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateDocumentTypeSchema = DocumentTypeSchema.partial();
